import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Bir hata oluştu. Lütfen tekrar deneyin.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const CATEGORIES = {
  elektrik: { label: "Elektrik", color: "#F59E0B", icon: "Zap" },
  su: { label: "Su", color: "#06B6D4", icon: "Droplet" },
  internet: { label: "İnternet", color: "#8B5CF6", icon: "Wifi" },
  telefon: { label: "Telefon", color: "#3B82F6", icon: "Phone" },
  aidat: { label: "Aidat", color: "#10B981", icon: "Building2" },
  diger: { label: "Diğer", color: "#94A3B8", icon: "Receipt" },
};

export const EXPENSE_CATEGORIES = {
  kira: { label: "Kira", color: "#F97316", icon: "Home" },
  telefon: { label: "Telefon", color: "#3B82F6", icon: "Phone" },
  yakit: { label: "Yakıt", color: "#EF4444", icon: "Fuel" },
  market: { label: "Market", color: "#10B981", icon: "ShoppingCart" },
  vergi: { label: "Vergi", color: "#8B5CF6", icon: "Landmark" },
  temizlik: { label: "Temizlik", color: "#06B6D4", icon: "Sparkles" },
  bakim: { label: "Bakım/Onarım", color: "#F59E0B", icon: "Wrench" },
  fatura: { label: "Fatura", color: "#0EA5E9", icon: "Receipt" },
  diger: { label: "Diğer", color: "#94A3B8", icon: "Receipt" },
};

export const fmtTL = (n) =>
  new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY", maximumFractionDigits: 0 }).format(n || 0);

export const fmtMoney = (n, cur) =>
  cur === "USD"
    ? new Intl.NumberFormat("tr-TR", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(n || 0)
    : fmtTL(n);

export const fmtPay = (p) => {
  if (p.currency !== "USD") return fmtTL(p.total_salary);
  return fmtMoney(p.net_usd ?? p.salary_net, "USD");
};

export const fmtTLx = (n, p) =>
  p?.currency === "USD" && p?.fx ? `${fmtTL(n)} (${fmtMoney((n || 0) / p.fx, "USD")})` : fmtTL(n);

export default api;
